import React, { useState, useEffect } from 'react';
import './styles.css';

const MobileResearch = ({ isDarkMode }) => {
    const [researchData, setResearchData] = useState([]);

    useEffect(() => {
        fetch('/data/research.json')
            .then(response => response.json())
            .then(data => {
                const research = data.sort((a, b) => b.id - a.id);
                setResearchData(research);
            })
            .catch(error => console.error('Error fetching research data:', error));
    }, []);

    return (
        <div className="mobile-page">
            <div className="mobile-content-wrapper">
                <div className="mobile-page-header">
                    <h1 className="mobile-page-header-title">Research</h1>
                    <div className="mobile-page-header-accent"></div>
                </div>

                <div className="mobile-content-section">
                    {researchData.length > 0 ? (
                        researchData.map((research, index) => (
                            <div key={index} className="mobile-card">
                                <div className="mobile-card-header">
                                    <h3 className="mobile-card-title">{research.title}</h3>
                                    <span className="mobile-card-period">{research.year}</span>
                                </div>
                                <p className="mobile-card-subtitle">{research.acceptedAt}</p>
                                {research.image && (
                                    <img
                                        src={research.image}
                                        alt={research.title}
                                        className="mobile-research-image"
                                    />
                                )}
                                <p className="mobile-card-description">{research.summary}</p>
                                {research.keyResults && research.keyResults.length > 0 && (
                                    <div className="mobile-card-results">
                                        <p>Key Results:</p>
                                        <ul>
                                            {research.keyResults.map((result, idx) => (
                                                <li key={idx}>{result}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                                {(research.url || research.pdfFileName) && (
                                    <div className="mobile-research-links">
                                        {research.url && (
                                            <a
                                                href={research.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="mobile-research-link"
                                            >
                                                <i className="fa-solid fa-arrow-up-right-from-square"></i> View Publication
                                            </a>
                                        )}
                                        {research.pdfFileName && (
                                            <a
                                                href={`/researchPapers/${research.pdfFileName}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="mobile-research-link"
                                            >
                                                <i className="fa-solid fa-file-pdf"></i> PDF
                                            </a>
                                        )}
                                    </div>
                                )}
                            </div>
                        ))
                    ) : (
                        <div className="mobile-card">
                            <p className="mobile-card-description">
                                My research is currently undergoing peer review... by me. I'm a tough critic, ya know.
                                <br /><br />
                                In the meantime, imagine some really impressive graphs, a few "statistically significant" results, and at least one equation that looks way more complicated than it needs to be.
                                <br /><br />
                                Expected timeline? Coming Soon!
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MobileResearch;
